import { useEntityPageContext } from './EntityContext';

/** The source's breadcrumb trail, given its own component as `as`. */
const EntityBreadcrumbs = ({ as: BreadCrumbs, ...rest }) => {
    const { hierarchyHint, generateLocation } = useEntityPageContext();

    return (
        <BreadCrumbs
            cat1={hierarchyHint?.cat1}
            generateLocation={generateLocation}
            {...rest}
        />
    );
};

export default EntityBreadcrumbs;
